import { render, staticRenderFns } from "./MMP_Rivian_RRHD.vue?vue&type=template&id=00fff248&"
import script from "./MMP_Rivian_RRHD.vue?vue&type=script&lang=js&"
export * from "./MMP_Rivian_RRHD.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports